import {
  CheckNotes,
  InspectionCase,
  InspectionWaterFlowCase
} from '../../inspection-cases';
import { DieselShutdownPump } from './diesel-shutdown-pump.dto';
import { ElectricShutdownPump } from './electric-shutdown-pump.dto';
import { FireExtinguishingPumpsInstallation } from './fire-extinguishing-pumps-installation.dto';
import { WaterFlowTest } from './water-flow-test.dto';

export class PumpDto extends InspectionCase {
  fireExtinguishingPumpsInstallation?: FireExtinguishingPumpsInstallation;
  dieselShutdownPump?: DieselShutdownPump;
  electricShutdownPump?: ElectricShutdownPump;
  waterFlowTest?: WaterFlowTest;
  waterFlowData?: InspectionWaterFlowCase;
}

export class Pump extends PumpDto {
  constructor(
    data: PumpDto = {
      isApplicable: true
    }
  ) {
    super(data);
    this.fireExtinguishingPumpsInstallation =
      new FireExtinguishingPumpsInstallation(
        data.fireExtinguishingPumpsInstallation
      );
    this.dieselShutdownPump = new DieselShutdownPump(data.dieselShutdownPump);
    this.electricShutdownPump = new ElectricShutdownPump(
      data.electricShutdownPump
    );
    this.waterFlowTest = new WaterFlowTest(data.waterFlowTest);
    this.waterFlowData = new InspectionWaterFlowCase(data.waterFlowData);
  }

  setInspectionStatus(): void {
    this.fireExtinguishingPumpsInstallation.setInspectionStatus();
    this.dieselShutdownPump.setInspectionStatus();
    this.electricShutdownPump.setInspectionStatus();
    this.waterFlowTest.setInspectionStatus();

    this.isPassed =
      this.fireExtinguishingPumpsInstallation.isPassed &&
      this.dieselShutdownPump.isPassed &&
      this.electricShutdownPump.isPassed &&
      this.waterFlowTest.isPassed &&
      (!this.waterFlowData.isApplicable || this.waterFlowData.isPassed);

    this.isApplicable =
      this.fireExtinguishingPumpsInstallation.isApplicable ||
      this.dieselShutdownPump.isApplicable ||
      this.electricShutdownPump.isApplicable ||
      this.waterFlowTest.isApplicable ||
      this.waterFlowData.isApplicable;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }

    return [
      ...this.fireExtinguishingPumpsInstallation.getNotes(),
      ...this.dieselShutdownPump.getNotes(),
      ...this.electricShutdownPump.getNotes(),
      ...this.waterFlowTest.getNotes()
    ];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.fireExtinguishingPumpsInstallation.setAsApplicable();
    this.dieselShutdownPump.setAsApplicable();
    this.electricShutdownPump.setAsApplicable();
    this.waterFlowTest.setAsApplicable();
    this.waterFlowData.setAsApplicable();
  }
}
